import { render, staticRenderFns } from "./Quack.vue?vue&type=template&id=4c90676b&scoped=true&"
import script from "./Quack.vue?vue&type=script&lang=ts&"
export * from "./Quack.vue?vue&type=script&lang=ts&"
import style0 from "./Quack.vue?vue&type=style&index=0&id=4c90676b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c90676b",
  null
  
)

export default component.exports